<template>
  <div id="contenedor-registrar-nuevo-convenio">
    <v-form
      v-model="formularioValido"
      ref="registrarNuevoContratoConvenioModificatorio">
      <v-card>
        <v-card-title class="secondary--text">
          Registrar nuevo convenio
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row align="center">
            <custom-date-picker
              cols="12"
              md="5"
              v-model="contratoConvenioModificatorio.fecha"
              label="Fecha"
              :rules="[mixReglas.requerido]">
            </custom-date-picker>
            <custom-select
              cols="12"
              md="7"
              v-model="contratoConvenioModificatorio.tipo"
              label="Tipo de Convenio Modificatorio"
              :items="tiposConvenios">
            </custom-select>
            <custom-text-field
              cols="12"
              v-model="contratoConvenioModificatorio.numero"
              label="Número"
              :rules="[mixReglas.requerido]">
            </custom-text-field>
            <v-col
              v-if="isPlazo"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Nuevo Plazo</v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <custom-date-picker
                      cols="12"
                      md="6"
                      v-model="contratoConvenioModificatorio.fechaInicio"
                      label="Fecha Inicio"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                    <custom-date-picker
                      cols="12"
                      md="6"
                      v-model="contratoConvenioModificatorio.fechaTermino"
                      label="Fecha Termino"
                      :rules="[mixReglas.requerido]">
                    </custom-date-picker>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="isMeta"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Nueva Meta</v-card-title>
                <v-card-text>
                  <v-row align="center">
                    <custom-text-field
                      cols="12"
                      v-model="contratoConvenioModificatorio.objeto"
                      label="Meta"
                      key="metaContrato"
                      :rules="[mixReglas.requerido]">
                    </custom-text-field>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col
              v-if="isMonto"
              cols="12"
              class="pa-1">
              <v-card style="border: 1px solid #6A83B5;" flat class="rounded-lg">
                <v-card-title>Datos del monto</v-card-title>
                <v-card-text>
                  <v-row>
                    <template
                      v-if="contrato.esObraFinanciada">
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoDirecto"
                        label="Importe Costo Directo"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="calcularCostosDeFinanciamiento">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoIndirectos"
                        label="Importe Indirectos"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeUtilidad"
                        label="Importe Utilidad"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCargosAdicionales"
                        label="Importe Adicionales"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <custom-text-field-green
                        cols="6"
                        v-model.number="contratoConvenioModificatorio.importeCostoFinanciero"
                        label="Importe C. Financiero"
                        es-dinero
                        prefix="$"
                        :rules="[mixReglas.requerido]"
                        @keyup="sumarImportesFinanciado">
                      </custom-text-field-green>
                      <v-col
                        cols="12">
                        <v-divider></v-divider>
                      </v-col>
                    </template>
                    <custom-text-field-green
                      cols="9"
                      v-model.number="contratoConvenioModificatorio.importe"
                      label="Importe"
                      es-dinero
                      prefix="$"
                      :rules="[mixReglas.requerido]"
                      @keyup="calcularTotalPorTipo">
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="3"
                      v-model.number="contratoConvenioModificatorio.porcentajeIva"
                      label="% IVA"
                      prefix="%"
                      readonly
                      disabled>
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="6"
                      v-model.number="contratoConvenioModificatorio.iva"
                      label="Importe IVA"
                      es-dinero
                      prefix="$"
                      readonly
                      disabled>
                    </custom-text-field-green>
                    <custom-text-field-green
                      cols="6"
                      v-model.number="contratoConvenioModificatorio.total"
                      label="Total"
                      es-dinero
                      prefix="$"
                      readonly
                      disabled>
                    </custom-text-field-green>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <custom-text-field
              cols="12"
              v-model="contratoConvenioModificatorio.motivo"
              label="Motivo - Justificación">
            </custom-text-field>
          </v-row>
        </v-card-text>
        <v-divider class="bkground" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixAgregarConvenio"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import customTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixConvenioContrato from './mixConvenioContrato';

export default {
  name: 'RegistrarNuevoContratoConvenioModificatorio',
  mixins: [mixConvenioContrato],
  components: {
    CustomTextField,
    customTextFieldGreen,
    CustomDatePicker,
    CustomSelect,
    CustomButton,
  },
  props: {
    contrato: Object,
  },
  data() {
    return {
      contratistaSelected: null,
      formularioValido: false,
      enviandoFormulario: false,
      contratoConvenioModificatorio: {
        idContrato: null, // ! String
        // idObra: ID,
        numero: null, // ! String
        fecha: new Date().toISOString().substr(0, 10), // ! String
        tipo: 'PLAZO', // ! String
        motivo: null, // String,
        objeto: null, // String,
        fechaInicio: new Date().toISOString().substr(0, 10), // String
        fechaTermino: new Date().toISOString().substr(0, 10), // String
        importeCostoDirecto: 0,
        importeCostoIndirectos: 0,
        importeUtilidad: 0,
        importeCargosAdicionales: 0,
        importeCostoFinanciero: 0,
        importe: 0, // Double
        porcentajeIva: this.contrato.porcentajeIva, // Int
        iva: 0, // Double
        total: 0, // Double
      },
      tiposConvenios: [
        'PLAZO',
        'REPROGRAMACIÓN',
        'MONTO - AMPLIACIÓN',
        'MONTO - REDUCCIÓN',
        'PLAZO - MONTO AMPLIACIÓN',
        'FINANCIERO',
        'CAMBIO DE META',
      ],
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.registrarNuevoContratoConvenioModificatorio.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
